import React from 'react';
import {graphql, compose} from 'react-apollo';
import {withRouter} from 'react-router-dom';
import StoreOrderPage from '../pages/StoreOrderPage';
import {
  STORE_ORDER_TEMPLATE_QUERY,
  CREATE_STORE_ORDER_MUTATION
} from '../queries';
import loadingSpinner from '../../shared/hoc/loadingSpinner';
import errorIfNotFound from '../../shared/hoc/errorIfNotFound';

class StoreOrderPageContainer extends React.Component {
  state = {
    submitting: false,
    submitSuccess: false
  };

  handleSubmit = async formData => {
    const {createStoreOrder, match, history} = this.props;
    const {templateId, ticketId} = match.params;

    this.setState({submitting: true});

    try {
      await createStoreOrder({
        variables: {
          storeOrder: {
            templateId,
            ticketId,
            formData
          }
        }
      });

      this.setState({submitting: false, submitSuccess: true});

      // Redirect back to ticket after a brief delay
      setTimeout(() => {
        history.push(`/ticket/${ticketId}`);
      }, 2000);
    } catch (error) {
      this.setState({submitting: false});
      console.error('Error submitting store order:', error);
      alert('Failed to submit order. Please try again.');
    }
  };

  render() {
    const {template, match, currentUser, history} = this.props;
    const {ticketId} = match.params;

    return (
      <StoreOrderPage
        template={template}
        ticketId={ticketId}
        currentUser={currentUser}
        onSubmit={this.handleSubmit}
        history={history}
        submitting={this.state.submitting}
        submitSuccess={this.state.submitSuccess}
      />
    );
  }
}

export default compose(
  withRouter,
  graphql(STORE_ORDER_TEMPLATE_QUERY, {
    options: ({match}) => ({
      variables: {
        templateId: match.params.templateId
      }
    }),
    props: ({data}) => ({
      loading: data.loading,
      error: data.error,
      template: data.storeOrderTemplate
    })
  }),
  graphql(CREATE_STORE_ORDER_MUTATION, {
    name: 'createStoreOrder'
  }),
  loadingSpinner,
  errorIfNotFound('template')
)(StoreOrderPageContainer);
